import { apiFetch } from "@/integrations/backend/client";

export type WeeklySummary = {
  week_starts_on: 0;
  weekly_goal: number | null;
  current_week: {
    start: string; // YYYY-MM-DD
    end: string; // YYYY-MM-DD
    completed: number;
    met: boolean;
  };
  current_streak_weeks: number;
  best_streak_weeks: number;
  completed_by_week_start: Record<string, number>;
};

export async function fetchWeeklySummary(): Promise<WeeklySummary> {
  const res = await apiFetch("/api/v1/dashboard/weekly-summary", { method: "GET" });
  if (!res.ok) throw new Error(`weekly_summary_failed:${res.status}`);
  return (await res.json()) as WeeklySummary;
}

